import { Typography } from "@mui/material";
import PropTypes from "prop-types";
import { getEuro } from "services/formatService.js";
import { getPercentValueWithMax } from "../helper.js";

SBWarning.propTypes = {
  item: PropTypes.object.isRequired,
  sparteObj: PropTypes.object,
  values: PropTypes.object,
};

export default function SBWarning(props) {
  const { item, sparteObj, values } = props;

  if (sparteObj === undefined) {
    return null;
  }

  let message = "";
  let variant = "body2";
  let color = "textSecondary";

  // Hole den ersten Wert aus der Hierarchie, der gesetzt ist
  let betrag = 0;
  if (Array.isArray(item.betrag)) {
    for (const key of item.betrag) {
      const val = Number(values[key]);
      if (!isNaN(val) && val > 0) {
        betrag = val;
        break;
      }
    }
  } else {
    betrag = Number(values[item.betrag] || 0);
  }

  const sbFix = Number(sparteObj.sb_fix || 0);
  const sbProzent = Number(sparteObj.sb_prozent || 0);
  const sbMin = Number(sparteObj.sb_min || 0);
  const sbMax = Number(sparteObj.sb_max || 0);

  // Feste Selbstbeteiligung
  if (sbFix) {
    if (!betrag) {
      message = `Ihre Selbstbeteiligung beträgt ${getEuro(sbFix)}.`;
    } else if (betrag < sbFix) {
      color = "warning.main";
      message = `Der Schaden liegt unter Ihrer Selbstbeteiligung von ${getEuro(sbFix)}. Eine Erstattung durch die Versicherung ist in diesem Fall nicht vorgesehen.`;
    } else if (betrag === sbFix) {
      color = "warning.main";
      color = "warning.main";
      message = `Der Schaden entspricht genau Ihrer Selbstbeteiligung von ${getEuro(sbFix)}. Eine Erstattung durch die Versicherung ist nicht zu erwarten.`;
    } else {
      color = "success.main";
      message = `Der Schaden übersteigt Ihre Selbstbeteiligung von ${getEuro(sbFix)}. Eine teilweise Erstattung durch die Versicherung ist möglich.`;
    }
  }

  // Selbstbeteiligung als Range
  if (sbProzent && sbMin && sbMax) {
    let realSbProzent = getPercentValueWithMax(betrag, sbProzent, sbMax);
    if (betrag && realSbProzent >= sbMin) {
      color = "success.main";
      message = `Ihre Selbstbeteiligung beträgt ${getEuro(realSbProzent)}.`;
    } else {
      message = `Ihre Selbstbeteiligung beträgt ${sbProzent} % (${getEuro(sbMin)} – ${getEuro(sbMax)}).`;
    }
  }

  if (message === "") return null;

  return (
    <>
      <Typography variant={variant} color={color}>
        {message}
      </Typography>
    </>
  );
}
